import styled from 'styled-components'

export const AppFooterWrapper = styled.div`
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin-bottom: 15px;

  .container {
    width: 1120px;
    margin: 0 auto;
    padding: 48px 24px;
    border-bottom: 1px solid #eee;
  }

  .links {
    display: flex;
    .item-group {
      flex: 1;
      .item-title {
        font-weight: 600;
        color: ${(props) => props.theme.color.main};
        margin-bottom: 16px;
      }
      .item-cell {
        font-weight: 600;
        color: ${(props) => props.theme.color.second};
        margin-bottom: 4px;
      }
    }
  }

  .info {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #eee;
    margin-top: 16px;
    padding-top: 16px;
    .left {
      display: flex;
      .logo {
        display: flex;
        align-items: center;
        margin-right: 8px;
      }
      .text {
        .icon {
          width: 20px;
          height: 20px;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      .tag {
        padding: 0 8px;
      }
    }
  }
`
